import { QUERY_TABLES } from '@/helpers/constants';
import { getRandomNumber900000to999999 } from '@/helpers/utility';
import { executeQuery } from 'src/helpers/request';

const buildQueryBranches = ({ tenantId }) => {
  const randomTenantId = getRandomNumber900000to999999();
  return {
    data: {
      fields: {
        branch_id: ['select'],
        branch_name: ['select'],
        branch_order: ['select'],
        tenant_id: ['select'],
      },
      skip: 0,
      limit: 0,
    },
    filter: {
      tenant_id: [tenantId, randomTenantId],
    },
    scale: {},
    evol: {},
    total: {
      all: [],
    },
    order: {
      branch_name: 'asc',
    },
    table_name: QUERY_TABLES.BRANCHES,
  };
};

const buildQueryFloors = ({ branchIdList }) => {
  const randomBranchId = getRandomNumber900000to999999();
  branchIdList = branchIdList || [];
  return {
    data: {
      fields: {
        floor_id: ['select'],
        floorplan_id: ['select'],
        floor_name: ['select'],
        branch_id: ['select'],
        floor_map: ['select'],
        floor_order: ['select'],
        related_floor_id: ['select'],
        related_product: ['select'],
        scale_x: ['select'],
        scale_y: ['select'],
      },
      skip: 0,
      limit: 0,
    },
    filter: {
      branch_id: [...branchIdList, randomBranchId],
    },
    scale: {},
    evol: {},
    total: {
      all: [],
    },
    order: {
      floor_order: 'asc',
    },
    table_name: QUERY_TABLES.FLOORS,
  };
};

const buildQueryArubaBuildings = ({ branchIdList }) => {
  const randomBranchId = getRandomNumber900000to999999();
  branchIdList = branchIdList || [];
  return {
    data: {
      fields: {
        building_id: ['select'],
        building_name: ['select'],
        branch_id: ['select'],
        tenant_id: ['select'],
      },
      skip: 0,
      limit: 0,
    },
    filter: {
      branch_id: [...branchIdList, randomBranchId],
    },
    scale: {},
    evol: {},
    total: {
      all: [],
    },
    order: {
      building_name: 'asc',
    },
    table_name: QUERY_TABLES.ARUBA_BUILDINGS,
  };
};

const buildQueryMerakiNetworks = ({ branchIdList }) => {
  const randomBranchId = getRandomNumber900000to999999();
  branchIdList = branchIdList || [];
  return {
    data: {
      fields: {
        network_identifer: ['select'],
        network_name: ['select'],
        branch_id: ['select'],
      },
      skip: 0,
      limit: 0,
    },
    filter: {
      branch_id: [...branchIdList, randomBranchId],
    },
    scale: {},
    evol: {},
    total: {
      all: [],
    },
    order: {
      network_name: 'asc',
    },
    table_name: QUERY_TABLES.MERAKI_NETWORKS,
  };
};

const buildQueryArubaFloors = ({ buildingIds }) => {
  const randomBuildingId = getRandomNumber900000to999999();
  buildingIds = buildingIds || [];
  return {
    data: {
      fields: {
        floor_identifer: ['select'],
        floor_name: ['select'],
        tenant_id: ['select'],
        building_id: ['select'],
        scale_x: ['select'],
        scale_y: ['select'],
      },
      skip: 0,
      limit: 0,
    },
    filter: {
      building_id: [...buildingIds, randomBuildingId],
    },
    scale: {},
    evol: {},
    total: {
      all: [],
    },
    order: {
      floor_name: 'asc',
    },
    table_name: QUERY_TABLES.ARUBA_FLOORS,
  };
};

const buildQueryMerakiFloors = ({ networkIds }) => {
  const randomNetworkId = getRandomNumber900000to999999();
  networkIds = networkIds || [];
  return {
    data: {
      fields: {
        floor_identifer: ['select'],
        floor_name: ['select'],
        tenant_id: ['select'],
        network_identifer: ['select'],
        scale_x: ['select'],
        scale_y: ['select'],
      },
      skip: 0,
      limit: 0,
    },
    filter: {
      network_identifer: [...networkIds, randomNetworkId],
    },
    scale: {},
    evol: {},
    total: {
      all: [],
    },
    order: {
      floor_name: 'asc',
    },
    table_name: QUERY_TABLES.MERAKI_FLOORS,
  };
};

export const fetchBranchList = async payload => {
  const { tenantId } = payload;
  const request = buildQueryBranches({ tenantId });
  return executeQuery(request);
};

export const fetchFloorListByBranchIdList = async payload => {
  const { branchIdList } = payload;
  const request = buildQueryFloors({ branchIdList });
  return executeQuery(request);
};

export const fetchArubaBuildingListByBranchIdList = async payload => {
  const { branchIdList } = payload;
  const request = buildQueryArubaBuildings({ branchIdList });
  return executeQuery(request);
};

export const fetchMerakiNetworkListByBranchIdList = async payload => {
  const { branchIdList } = payload;
  const request = buildQueryMerakiNetworks({ branchIdList });
  return executeQuery(request);
};

export const fetchArubaFloorListByBuildingIdList = async payload => {
  const { buildingIds } = payload;
  const request = buildQueryArubaFloors({ buildingIds });
  return executeQuery(request);
};

export const fetchMerakiFloorListByNetworkIdList = async payload => {
  const { networkIds } = payload;
  const request = buildQueryMerakiFloors({ networkIds });
  return executeQuery(request);
};
